import * as React from 'react';

import Card from '@material-ui/core/Card'; // , { CardContent }
import Typography from '@material-ui/core/Typography';

import './Appointment.css';
import ActionButton from '@crochik/pi-react/ui/material/ActionButton';

interface Props {
    time?: string;
    date?: string;
    onClick: Function;
    onCreateAppointment: Function;
}

export default class Appointment extends React.Component<Props> {
    onClick = () => {
        if (this.props.onClick) this.props.onClick();
    }

    render() {
        const { onCreateAppointment } = this.props;

        return (
            <Card className="Appointment">
                <div>
                    <Typography>
                        You have chosen an appointment&nbsp;
                        <a
                            style={{ textDecoration: 'none', color: '#2196f3', cursor: 'pointer' }}
                            href="#"
                            onClick={this.onClick}
                        >
                            at {this.props.time} on {this.props.date}
                        </a>
                    </Typography>
                </div>

                <div style={{ marginTop: 24, display: 'flex', justifyContent: 'space-around' }}>
                    {/* <ActionButton title="Reschedule" action={this.onClick} variant="contained" color="primary" /> */}
                    <ActionButton title="Book My Appointment!" action={onCreateAppointment} variant="contained" color="primary" />
                </div>
            </Card>
        );
    }
}


// WEBPACK FOOTER //
// ./src/app/pages/comps/Appointment/index.tsx